import * as React from 'react'
import { Helmet } from 'react-helmet-async'

import TextButtonWithIcon from '../../atoms/Button/Text/ButtonWithIcon'
import Headings from '../../atoms/Heading'
import Image from '../../atoms/Image'
import Paragraph from '../../atoms/Paragraph'
import Video from '../../atoms/Video'

interface Props {
  content?: any
  isArticle?: boolean
}

/**
 * Listing Component
 * @param content - Content from the CMS.
 * @param isArticle (optional) - To render article layout
 */
const Listing = ({ content, isArticle }: Props) => {
  const formatDate = (publishDate) => {
    return `${new Date(publishDate).toLocaleDateString('default', { day: 'numeric' })} ${new Date(publishDate).toLocaleDateString('default', { month: 'long' })} ${new Date(publishDate).toLocaleDateString('default', { year: 'numeric' })}`
  }

  return (
    <>
      <div
        data-testid="listing"
        className={`flex flex-col items-center gap-40 border-b border-neutral-50 bg-white py-32 last:border-0 lg:flex-row`}
      >
        {content?.iconUrl !== null && (
          <div className="flex w-full justify-start lg:w-[200px] lg:justify-center">
            <Image imageUrl={content?.iconUrl} altText="Listing Image" width="56" />
          </div>
        )}

        {content?.imageUrl !== null && (
          <div className="flex w-full justify-start lg:w-[200px] lg:justify-center">
            <Image imageUrl={content?.imageUrl} altText="Listing Image" />
          </div>
        )}

        <div className={content?.imageUrl !== null ? 'flex-1' : 'w-100 flex-1'}>
          <div className="">
            {content?.tag !== null && <Paragraph content={content?.tag} classes="!text-base text-neutral-90 pb-16" />}
            {content?.publishDate !== null && (
              <Paragraph content={formatDate(content?.publishDate)} classes="!text-base text-neutral-90 pb-16" />
            )}
            {content?.timeToRead !== null && (
              <Paragraph content={content?.timeToRead} classes="!text-base text-neutral-90 pb-24" />
            )}
            {content?.headLine !== null && <Headings content={content?.headLine} variant="H4" classes="text-black" />}
            {content?.contentDescription !== null && (
              <Paragraph content={content?.contentDescription} classes="text-black pb-32" />
            )}
            {content?.videoPodcastUrl !== null && content?.buzzsproutId === null && (
              <div className={`w-100 ${isArticle ? '' : 'md:w-75 xl:w-60'}`}>
                <Video videoUrl={content?.videoPodcastUrl} classes={`mt-16`} />
              </div>
            )}
            {content?.videoPodcastUrl !== null && content?.buzzsproutId !== null && (
              <>
                <div id={`buzzsprout-player-${content?.buzzsproutId}`}>&nbsp;</div>
                <Helmet>
                  <script
                    src={`${content?.videoPodcastUrl}?container_id=buzzsprout-player-${content?.buzzsproutId}&player=small`}
                    type="text/javascript"
                  ></script>
                </Helmet>
              </>
            )}
            {content?.videoPodcastUrl === null && (
              <>
                {content?.contentCtaLinkToPage !== null && Array.isArray(content?.contentCtaLinkToPage) ? (
                  content?.contentCtaLinkToPage.map((link: any, index) => {
                    return (
                      <span key={`link-${index}`}>
                        <TextButtonWithIcon
                          name={link.fields.ctaText}
                          underline={true}
                          variant={link.fields.ctaButtonVariety === 'TextDark' ? 'dark' : 'light'}
                          link={link.fields.buttonLinkExternal && link.fields.buttonLinkExternal}
                        />
                      </span>
                    )
                  })
                ) : (
                  <span>
                    <TextButtonWithIcon
                      name="Go to page"
                      underline={true}
                      variant="dark"
                      link={content?.contentCtaLinkToPage}
                    />
                  </span>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default Listing
